import { useQuery } from '@tanstack/vue-query'
import { gql } from 'graphql-tag'
import { storeToRefs } from 'pinia'
import { computed, toValue } from 'vue'
import { useGqlMikro } from '~/composables/useGqlMikro'
import { useOrganizationStore } from '~/stores/organization'
import type { CollectGraphqlFilters, CollectStatus } from '~/types/graphql-backend-types/gql-types'
import { AscDescGraphql } from '~/types/graphql-backend-types/gql-types'

export const COLLECTS_BY_STATUS_QUERY_KEY = (status: MaybeRefOrGetter<CollectStatus>) => ['collects-by-status', { status }]

export function useCollectsByStatus(status: MaybeRefOrGetter<CollectStatus>) {
  const { query } = useGqlMikro()
  const { selectedOrgId } = storeToRefs(useOrganizationStore())

  const filters = computed<CollectGraphqlFilters>(() => ({
    status: [toValue(status)],
    orderBy: { field: 'startsAt', order: AscDescGraphql.Desc },
    isRoundStop: false,
    hasRound: false,
    ...(selectedOrgId.value && { organizationIds: [selectedOrgId.value] }),
  }))

  return useQuery({
    queryKey: [...COLLECTS_BY_STATUS_QUERY_KEY(status), filters.value],
    queryFn: async () => {
      const { data, errors } = await query({
        query: COLLECTS_BY_STATUS_QUERY,
        variables: {
          pagination: { limit: 100, offset: 0 },
          filters: filters.value,
        },
      })

      if (errors && errors.length > 0) {
        throw errors
      }

      return data.collects
    },
  })
}

export const COLLECTS_BY_STATUS_QUERY = gql`
  query CollectsByStatus($pagination: PaginationArgs!, $filters: CollectGraphqlFilters) {
    collects(pagination: $pagination, filters: $filters) {
      count
      collection {
        id
        status
      }
    }
  }
`
